import React from "react";
//#region types
import { StateFlowProps } from "models/propTypes/stateFlowPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid, Stepper, Step, StepConnector, StepLabel, Grow } from "@mui/material";
import ProfileImage from "./profile/profileImage";
import Icon from "./icon";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const StateFlow: React.FC<StateFlowProps> = (props) => {
  const { steps, currentState, loading } = props;

  const getActiveStep = () => {
    if (currentState !== undefined) return steps.findIndex((step) => step.state === currentState);
    else {
      const next = steps.findIndex((step) => step.date === null);
      return next ? next - 1 : -1;
    }
  };

  const activeStep = getActiveStep();

  return (
    <Stepper
      activeStep={activeStep}
      className={cssExports.stateFlowContainer}
      connector={
        <StepConnector
          classes={{
            root: cssExports.stepConnector,
            line: cssExports.stepConnectorLine,
            disabled: cssExports.stepConnectorDisabled,
            active: cssExports.stepConnectorActive,
            completed: cssExports.stepConnectorActive,
          }}
        />
      }
      alternativeLabel
    >
      {steps.map((step, index) => {
        const isActiveStep = index <= activeStep;
        return (
          <Grow
            key={`${step.stateText}-${step.date}-${step.updatedById}-${index}`}
            in={true}
            style={{ transformOrigin: "0 0 0" }}
            timeout={loading ? undefined : index === 0 ? 0 : 300 + +index * 700}
          >
            <Step
              className={clsx(
                index === activeStep ? cssExports.stepActive : index > activeStep ? cssExports.stepDisabled : "",
                cssExports.statusFlowStep
              )}
            >
              <StepLabel
                classes={{
                  iconContainer: cssExports.stepIconContainer,
                  label: cssExports.stepLabel,
                }}
              >
                <Grid container direction="column" alignItems="center">
                  <Grid item>
                    <label className={cssExports.statusLabel}>{step.stateText}</label>
                  </Grid>
                  <Grid item className={cssExports.stateFlowIcon}>
                    {isActiveStep ? (
                      <ProfileImage
                        id={step.updatedById}
                        name={step.updatedByName ? step.updatedByName : ""}
                        className={cssExports.avatar}
                        showDefaultAvatar={!step.date}
                      ></ProfileImage>
                    ) : (
                      <Icon icon={IconDefinitionConstants.WBulletFuture} />
                    )}
                  </Grid>
                  <Grid item className={cssExports.stateFlowText}>
                    <span>
                      {step.date && isActiveStep
                        ? LocalizationHelperInstance.getFormattedDate(step.date, {
                            day: "numeric",
                            month: "short",
                          })
                        : ""}
                    </span>
                  </Grid>
                </Grid>
              </StepLabel>
            </Step>
          </Grow>
        );
      })}
    </Stepper>
  );
};

export default StateFlow;
